import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import { type CoreThemeColors, parseProfileThemeEvent } from '@/lib/themeEngine';

/**
 * Query the active profile theme (kind 16767) for a given pubkey.
 * Returns the 3 core colors if a theme is published, or null if none exists.
 */
export function useActiveProfileTheme(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery<CoreThemeColors | null>({
    queryKey: ['activeProfileTheme', pubkey],
    queryFn: async () => {
      if (!pubkey) return null;

      const events = await nostr.query(
        [{ kinds: [16767], authors: [pubkey], limit: 1 }],
        { signal: AbortSignal.timeout(5000) },
      );

      if (events.length === 0) return null;
      return parseProfileThemeEvent(events[0].tags);
    },
    enabled: !!pubkey,
    staleTime: 5 * 60 * 1000,
  });
}
